export default __webpack_public_path__ + "static/media/team.82a6bed9.jpg";